import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogPlanValuesComponent } from './dialog-plan-values.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [DialogPlanValuesComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    NgxSkeletonLoaderModule
  ]
})
export class DialogPlanValuesModule {}
